// Curated assistant guidance, separate from mutually shared peer interests.
const questions = [
    '🏠 Can freshmen live in campus housing?',
    '🍽️ Where can I eat lunch on campus?',
    '💸 Where can I find official financial aid information?',
    '🎓 Who can help me with admissions questions?',
    '🚗 How can I find student parking information?',
    '🤝 How do I connect and chat with peers in Nearpeer?',
    '👋 What can I ask you, Nerpy?',
    '🐉 Half dragon, half flea? Tell me your origin story!',
    '🎲 What do you like to do for fun?'
].map((starterText, index) => ({ id: `nerpy-guide-${index}`, starterText }));

exports.forName = (name = 'Nerpy') => questions.map((question) => ({ ...question, starterText: question.starterText.replace(/\bNerpy\b/g, () => name) }));
